module.exports = __webpack_public_path__ + "static/img/case1.b06b6f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/case1.png
// module id = sMxV
// module chunks = 19